@if(mode==="edit"){
@if(source !== 'enrollment'){
<div class="ppl-mt8 no-padding">
  @for(header of extractValues('header'); track $index){
  <h2>{{header}}</h2>
  }
  @for(text of extractValues('text'); track $index){
  <p class="ppl-description">{{text}}</p>
  }
</div>
}
<div [ngClass]="{'ppl-mt24': source !== 'enrollment'}">
  <nz-card nz-col [nzSpan]="source !== 'enrollment' ? 20 : 24" class="ppl-step-main" [nzBordered]="false">
    <form nz-form [formGroup]="infoForm" class="ppl-p0" appAutoFocusFirstInput>
      @if(isAttrAvailable('legalName')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="legalName"
          class="ppl-form-label">{{getAttributes('legalName').label}}
          @if(getAttributes('legalName').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('legalName')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input formControlName="legalName" id="legalName" autocomplete="off"
              placeholder="{{getAttributes('legalName').placeholder}}"
              [ngClass]="{'error': validationErrors['legalName'] }" />
          </div>
          @if (validationErrors['legalName']) {
          <span class="pl-1 error-message">{{validationErrors['legalName']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('businessName')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="businessName"
          class="ppl-form-label">{{getAttributes('businessName').label}}
          @if(getAttributes('businessName').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('businessName')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input formControlName="businessName" id="businessName" tabindex="0"
              placeholder="{{getAttributes('businessName').placeholder}}"
              [ngClass]="{'error': validationErrors['businessName'] }" />
          </div>
          @if (validationErrors['businessName']) {
          <span class="pl-1 error-message">{{validationErrors['businessName']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('vendorName')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="vendorName"
          class="ppl-form-label">{{getAttributes('vendorName').label}}
          @if(getAttributes('vendorName').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('vendorName')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input formControlName="vendorName" id="vendorName"
              placeholder="{{getAttributes('vendorName').placeholder}}"
              [ngClass]="{'error': validationErrors['vendorName'] }" />
          </div>
          @if (validationErrors['vendorName']) {
          <span class="pl-1 error-message">{{validationErrors['vendorName']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('doingBusinessAs')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="doingBusinessAs"
          class="ppl-form-label">{{getAttributes('doingBusinessAs').label}}
          @if(getAttributes('doingBusinessAs').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('doingBusinessAs')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input formControlName="dbaName" id="doingBusinessAs"
              placeholder="{{getAttributes('doingBusinessAs').placeholder}}"
              [ngClass]="{'error': validationErrors['doingBusinessAs'] }" />
          </div>
          @if (validationErrors['doingBusinessAs']) {
          <span class="pl-1 error-message">{{validationErrors['doingBusinessAs']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }      
      @if(isAttrAvailable('fname')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="fname" class="ppl-form-label">{{getAttributes('fname').label}}
          @if(getAttributes('fname').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('fname')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input formControlName="fname" id="fname" placeholder="{{getAttributes('fname').placeholder}}"
              [ngClass]="{'error': validationErrors['fname'] }" />
          </div>
          @if (validationErrors['fname']) {
          <span class="pl-1 error-message">{{validationErrors['fname']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('mname')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="mname" class="ppl-form-label">{{getAttributes('mname').label}}
          @if(getAttributes('mname').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('mname')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input formControlName="mname" id="mname" placeholder="{{getAttributes('mname').placeholder}}"
              [ngClass]="{'error': validationErrors['mname'] }" />
          </div>
          @if (validationErrors['mname']) {
          <span class="pl-1 error-message">{{validationErrors['mname']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('lname')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="lname" class="ppl-form-label">{{getAttributes('lname').label}}
          @if(getAttributes('lname').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('lname')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input formControlName="lname" id="lname" placeholder="{{getAttributes('lname').placeholder}}"
              [ngClass]="{'error': validationErrors['lname'] }" />
          </div>
          @if (validationErrors['lname']) {
          <span class="pl-1 error-message">{{validationErrors['lname']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('maiden_name')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="maiden_name"
          class="ppl-form-label">{{getAttributes('maiden_name').label}}
          @if(getAttributes('maiden_name').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('maiden_name')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input formControlName="maiden_name" id="maiden_name"
              placeholder="{{getAttributes('maiden_name').placeholder}}"
              [ngClass]="{'error': validationErrors['maiden_name'] }" />
          </div>
          @if (validationErrors['maiden_name']) {
          <span class="pl-1 error-message">{{validationErrors['maiden_name']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('dob')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="dob" class="ppl-form-label">{{getAttributes('dob').label}}
          @if(getAttributes('dob').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('dob')?.tooltip || ''" nzTooltipPlacement="topRight">
            <!-- <nz-date-picker formControlName="dob" id="dob" [nzFormat]="'MM/dd/yyyy'" [nzAllowClear]="false"
              [nzPlaceHolder]="getAttributes('dob').placeholder" [nzDisabledDate]="disabledDate"
              [ngClass]="{'error': validationErrors['dob'] }"></nz-date-picker>  -->
            <ppl-date-picker formControlName="dob" id="dob" [showIcon]="true" [placeholder]="getAttributes('dob').label"
              dateFormat="mm/dd/yy" [readonlyInput]="false" [monthNavigator]="true" [yearNavigator]="true"
              [yearRange]="'1900:2050'" [iconDisplay]="'input'" inputId="icondisplay"
              [panelStyleClass]="'custom-calendar-panel'" [maxDate]="yesterday"
              [styleClass]="validationErrors['dob'] ? 'error' : ''">
            </ppl-date-picker>
          </div>
          @if (validationErrors['dob']) {
          <span class="pl-1 error-message">{{validationErrors['dob']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('conservatorship')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="conservatorship" class="ppl-form-label">{{getAttributes('conservatorship').label}}
          @if(getAttributes('conservatorship').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('conservatorship')?.tooltip || ''" nzTooltipPlacement="topRight"
            [ngClass]="{'error': validationErrors['conservatorship'] }">
            <ppl-dropdown-select formControlName="conservatorship" id="conservatorship" [options]="conservatorshipTypes"
              [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              [placeholder]="getAttributes('conservatorship').placeholder">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['conservatorship']) {
          <span class="pl-1 error-message">{{validationErrors['conservatorship']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('gender')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="gender" class="ppl-form-label">
          <span id="gender-label">
            {{getAttributes('gender').label}}
            @if(getAttributes('gender').mandatory === 'Y'){
            <span>*</span>
            }
          </span>
        </nz-form-label>
        <nz-form-control [nzSm]="16" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('gender')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="gender" class="ppl-radio-group" id="gender" role="radiogroup"
              aria-labelledby="gender-label" [ngClass]="{'error': validationErrors['gender'] }">
              @for(opt of gender; track $index){
              <label nz-radio-button [nzValue]="opt.lkpValueCode">{{opt.lkpValueName}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['gender']) {
          <span class="pl-1 error-message">{{validationErrors['gender']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('servicesAtBusinessLocation')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="servicesAtBusinessLocation" class="ppl-form-label">
          <span id="servicesAtBusinessLocation-label">
            {{getAttributes('servicesAtBusinessLocation').label}}
            @if(getAttributes('servicesAtBusinessLocation').mandatory === 'Y'){
            <span>*</span>
            }
          </span>
        </nz-form-label>
        <nz-form-control [nzSm]="16" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('servicesAtBusinessLocation')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="servicesAtBusinessLocation" class="ppl-radio-group" id="servicesAtBusinessLocation"
              role="radiogroup" aria-labelledby="servicesAtBusinessLocation-label"
              [ngClass]="{'error': validationErrors['servicesAtBusinessLocation'] }">
              @for(opt of radioOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['servicesAtBusinessLocation']) {
          <span class="pl-1 error-message">{{validationErrors['servicesAtBusinessLocation']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('servingIndividualsWithDisabilities')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="servingIndividualsWithDisabilities" class="ppl-form-label">
          <span id="servingIndividualsWithDisabilities-label">
            {{getAttributes('servingIndividualsWithDisabilities').label}}
            @if(getAttributes('servingIndividualsWithDisabilities').mandatory === 'Y'){
            <span>*</span>
            }
          </span>
        </nz-form-label>
        <nz-form-control [nzSm]="16" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('servingIndividualsWithDisabilities')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="servingIndividualsWithDisabilities" class="ppl-radio-group" id="servingIndividualsWithDisabilities"
              role="radiogroup" aria-labelledby="servingIndividualsWithDisabilities-label"
              [ngClass]="{'error': validationErrors['servingIndividualsWithDisabilities'] }">
              @for(opt of radioOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['servingIndividualsWithDisabilities']) {
          <span class="pl-1 error-message">{{validationErrors['servingIndividualsWithDisabilities']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('SSN')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="SSN" class="ppl-form-label">{{getAttributes('SSN').label}}
          @if(isSsnMandatory()){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('SSN')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-input-group [nzSuffix]="suffixTemplate" [ngClass]="{'error': validationErrors['SSN'] }">
              <input nz-input [type]="ssnVisible ? 'text' : 'password'" formControlName="SSN" id="SSN"
                placeholder="{{getAttributes('SSN').placeholder}}" (input)="limitDigits($event)" />
            </nz-input-group>
          </div>
          <ng-template #suffixTemplate>
            <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
            <button class="ssn-visible" type="button"
              [attr.aria-label]="ssnVisible ? 'Hide SSN Clickable Button' : 'Show SSN Clickable Button'" nz-icon
              [nzType]="ssnVisible ? 'eye' : 'eye-invisible'" (click)="toggleSSN()">
            </button>
            <div aria-live="polite" aria-atomic="true" class="sr-only">
              {{ liveSsnAnnouncement }}
            </div>
          </ng-template>
          @if (validationErrors['SSN']) {
          <span class="pl-1 error-message">{{validationErrors['SSN']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('ITIN')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="ITIN" class="ppl-form-label">{{getAttributes('ITIN').label}}
          @if(isItinMandatory()){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('ITIN')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-input-group [nzSuffix]="itinSuffixTemplate" [ngClass]="{'error': validationErrors['ITIN'] }">
              <input nz-input [type]="itinVisible ? 'text' : 'password'" formControlName="ITIN" id="ITIN"
                placeholder="{{getAttributes('ITIN').placeholder}}" (input)="limitItinDigits($event)" />
            </nz-input-group>
          </div>
          <ng-template #itinSuffixTemplate>
            <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
            <button class="ssn-visible" type="button"
              [attr.aria-label]="itinVisible ? 'Hide ITIN Clickable Button' : 'Show ITIN Clickable Button'" nz-icon
              [nzType]="itinVisible ? 'eye' : 'eye-invisible'" (click)="toggleITIN()">
            </button>
            <div aria-live="polite" aria-atomic="true" class="sr-only">
              {{ liveItinAnnouncement }}
            </div>
          </ng-template>
          @if (validationErrors['ITIN']) {
          <span class="pl-1 error-message">{{validationErrors['ITIN']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('CIN')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="CIN" class="ppl-form-label">{{getAttributes('CIN').label}}
          @if(getAttributes('CIN').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('CIN')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input id="CIN" formControlName="CIN" placeholder="{{getAttributes('CIN').placeholder}}"
              [ngClass]="{'error': validationErrors['CIN'] }" (input)="limitCIN($event)" />
          </div>
          @if (validationErrors['CIN']) {
          <span class="pl-1 error-message">{{validationErrors['CIN']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('EIN')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="EIN" class="ppl-form-label">{{getAttributes('EIN').label}}
          @if(isEinMandatory()){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('EIN')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-input-group [nzSuffix]="einSuffixTemplate" [ngClass]="{'error': validationErrors['EIN'] }">
              <input nz-input [type]="einVisible ? 'text' : 'password'" formControlName="EIN" id="EIN"
                placeholder="{{getAttributes('EIN').placeholder}}" autocomplete="off"
                (input)="limitDigits($event, 'EIN')" />
            </nz-input-group>
          </div>
          <ng-template #einSuffixTemplate>
            <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
            <button class="ssn-visible" type="button"
              [attr.aria-label]="einVisible ? 'Hide EIN Clickable Button' : 'Show EIN Clickable Button'" nz-icon
              [nzType]="einVisible ? 'eye' : 'eye-invisible'" (click)="toggleEIN()">
            </button>
          </ng-template>
          @if (validationErrors['EIN']) {
          <span class="pl-1 error-message">{{validationErrors['EIN']}}</span>
          }
          @if(flow === 'employer'){
          <div class="notes">
            <strong>Notes:</strong>
            <p>
              1. If EIN is lost/misplaced, then obtain your existing EIN using "<a>How to ask the IRS
                for a
                147c letter</a>".
            </p>
            <p>
              2. If EIN doesn't exist, PPL will obtain an EIN on your behalf after completion and
              submission
              of registration paperwork.
            </p>
          </div>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('TIN')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="TIN" class="ppl-form-label">{{getAttributes('TIN').label}}
          @if(getAttributes('TIN').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('TIN')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-input-group [nzSuffix]="tinSuffixTemplate" [ngClass]="{'error': validationErrors['TIN'] }">
              <input nz-input [type]="tinVisible ? 'text' : 'password'" formControlName="TIN" id="TIN"
                placeholder="{{getAttributes('TIN').placeholder}}" autocomplete="off" />
            </nz-input-group>
          </div>
          <ng-template #tinSuffixTemplate>
            <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
            <button class="ssn-visible" type="button"
              [attr.aria-label]="tinVisible ? 'Hide TIN Clickable Button' : 'Show TIN Clickable Button'" nz-icon
              [nzType]="tinVisible ? 'eye' : 'eye-invisible'" (click)="toggleTIN()">
            </button>
          </ng-template>
          @if (validationErrors['TIN']) {
          <span class="pl-1 error-message">{{validationErrors['TIN']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }      
      
      @if(isAttrAvailable('isProvidingServices')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="isProvidingServices"
          class="ppl-form-label">{{getAttributes('isProvidingServices').label}}
          @if(getAttributes('isProvidingServices').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control [nzSm]="16" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('isProvidingServices')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="isProvidingServices" class="ppl-radio-group" id="isProvidingServices"
              [ngClass]="{'error': validationErrors['isProvidingServices'] }">
              @for(opt of radioOptions; let idx = $index; track idx){
              <label nz-radio-button [nzValue]="opt.value"
                [attr.tabindex]="!isProvidingServicesSelected && idx === 0 ? '0' : null">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['isProvidingServices']) {
          <span class="pl-1 error-message">{{validationErrors['isProvidingServices']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('servicesRendered')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="servicesRendered"
          class="ppl-form-label">{{getAttributes('servicesRendered').label}}
          @if(getAttributes('servicesRendered').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div [ngClass]="{'error': validationErrors['servicesRendered'] }">
            <ppl-multiselect formControlName="servicesRendered" id="servicesRendered" [options]="services"
              style="width:100%; margin-bottom: 16px" [showClear]="true"
              placeholder="{{getAttributes('servicesRendered').placeholder}}" [optionLabel]="'lkpValueName'"
              [optionValue]="'lkpValueCode'" [disabled]="false" [maxTagCount]="4"
              style="width:100%; margin-bottom: 16px" (ngModelChange)="onServicesRenderedChange($event)">
            </ppl-multiselect>
          </div>
          @if (validationErrors['servicesRendered']) {
          <span class="pl-1 error-message">{{validationErrors['servicesRendered']}}</span>
          }

        </nz-form-control>
      </nz-form-item>
      }
      @if(showServicesRenderedAdditionalDetails && isAttrAvailable('servicesRenderedAdditionalDetails')){
        <nz-form-item class="ppl-form-item">
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="servicesRenderedAdditionalDetails" class="ppl-form-label">
            <span id="otherReferralSource-label">
              {{getAttributes('servicesRenderedAdditionalDetails').label}}
              @if(getAttributes('servicesRenderedAdditionalDetails').mandatory === 'Y'){
              <span>*</span>
              }
            </span>
          </nz-form-label>
          <nz-form-control [nzSm]="16" class="ppl-form-control">
            <div nz-tooltip [nzTooltipTitle]="getAttributes('servicesRenderedAdditionalDetails')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input formControlName="servicesRenderedAdditionalDetails" id="servicesRenderedAdditionalDetails"
                placeholder="{{getAttributes('servicesRenderedAdditionalDetails').placeholder}}"
                [ngClass]="{'error': validationErrors['maiden_name'] }" />
            </div>
            @if (validationErrors['servicesRenderedAdditionalDetails']) {
            <span class="pl-1 error-message">{{validationErrors['servicesRenderedAdditionalDetails']}}</span>
            }
          </nz-form-control>
        </nz-form-item>
      }
      @if(isAttrAvailable('currentFms')){
        <nz-form-item class="ppl-form-item">
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="currentFms" class="ppl-form-label">
            <span id="program-label">
              {{getAttributes('currentFms').label}}
              @if(getAttributes('currentFms').mandatory === 'Y'){
              <span>*</span>
              }
            </span>
          </nz-form-label>
          <nz-form-control [nzSm]="16" class="ppl-form-control">
            <div nz-tooltip [nzTooltipTitle]="getAttributes('currentFms')?.tooltip || ''" nzTooltipPlacement="topRight">

              <ppl-dropdown-select formControlName="currentFms" id="currentFms" [options]="currentFmsList"
                    [optionLabel]="'orgName'" [optionValue]="'orgId'" [placeholder]="'Please select Current FMS'">
              </ppl-dropdown-select>
            </div>
            @if (validationErrors['currentFms']) {
            <span class="pl-1 error-message">{{validationErrors['currentFms']}}</span>
            }
          </nz-form-control>
        </nz-form-item>
      }
      @if(isAttrAvailable('program')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="programs" class="ppl-form-label">
          <span id="program-label">
            {{getAttributes('program').label}}
            @if(getAttributes('program').mandatory === 'Y'){
            <span>*</span>
            }
          </span>
        </nz-form-label>
        <nz-form-control [nzSm]="16" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('program')?.tooltip || ''" nzTooltipPlacement="topRight">

            <ppl-dropdown-select formControlName="program" id="program" [options]="programs"
                  [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'" [placeholder]="'Select a Program'"
                  (selectionChange)="onProgramChange($event)"></ppl-dropdown-select>
          </div>
          @if (validationErrors['program']) {
          <span class="pl-1 error-message">{{validationErrors['program']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('regionalCenter')){
      <nz-form-item nz-col nzSpan="24" class="ppl-form-item nz-padding-left">
        <nz-row>
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="regionalCenter"
            class="ppl-form-label">{{getAttributes('regionalCenter').label}}
            @if(getAttributes('regionalCenter').mandatory === 'Y'){
            <span>*</span>
            }
          </nz-form-label>

          <nz-form-control [nzSm]="16" [nzXs]="24" class="ppl-form-control">
            <div nz-tooltip [nzTooltipTitle]="getAttributes('regionalCenter')?.tooltip || ''" nzTooltipPlacement="topRight">
              <div [ngClass]="{'error': validationErrors['regionalCenter'] }">
                <ppl-dropdown-select formControlName="regionalCenter" id="regionalCenter" [options]="regionalCenters"
                  [optionLabel]="'orgName'" [optionValue]="'orgId'" [placeholder]="'Select Regional Center'" (selectionChange)="onRegionalCenterChange($event)"></ppl-dropdown-select>
              </div>
            </div>
            @if (validationErrors['regionalCenter']) {
            <span class="pl-1 error-message">{{validationErrors['regionalCenter']}}</span>
            }
          </nz-form-control>

        </nz-row>
      </nz-form-item>
      }
      @if(isAttrAvailable('recieveGoodsAndServices')){
        <nz-form-item class="ppl-form-item">
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="recieveGoodsAndServices" class="ppl-form-label">
            <span id="program-label">
              {{getAttributes('recieveGoodsAndServices').label}}
              @if(getAttributes('recieveGoodsAndServices').mandatory === 'Y'){
              <span>*</span>
              }
            </span>
          </nz-form-label>
          <nz-form-control [nzSm]="16" class="ppl-form-control">
            <div nz-tooltip [nzTooltipTitle]="getAttributes('recieveGoodsAndServices')?.tooltip || ''" nzTooltipPlacement="topRight">

              <ppl-dropdown-select formControlName="recieveGoodsAndServices" id="recieveGoodsAndServices" [options]="recieveGoodsAndServicesList"
                    [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueName'" [placeholder]="'Will the Participant receive goods and services only'" [tabindex]="0">
              </ppl-dropdown-select>
            </div>
            @if (validationErrors['recieveGoodsAndServices']) {
            <span class="pl-1 error-message">{{validationErrors['recieveGoodsAndServices']}}</span>
            }
          </nz-form-control>
        </nz-form-item>
      }      
      @if(isAttrAvailable('waiver')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="waiver" class="ppl-form-label">{{getAttributes('waiver').label}}
          @if(getAttributes('waiver').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('waiver').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['waiver'] }">
            <ppl-dropdown-select formControlName="waiver" id="waiver" [options]="waiver" [optionLabel]="'lkpValueName'"
              [optionValue]="'lkpValueCode'" placeholder="Select Service Administration" role="combobox"
              aria-required="true" aria-describedby="waiverError" [attr.aria-label]="'Select Service Administration'"
              [attr.aria-invalid]="validationErrors['waiver'] ? 'true' : 'false'">
            </ppl-dropdown-select>
          </div>

          @if (validationErrors['waiver']) {
          <span id="waiverError" class="pl-1 error-message" role="alert">
            {{validationErrors['waiver']}}
          </span>
          }


        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('ldssOffice')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="ldssOffice"
          class="ppl-form-label">{{getAttributes('ldssOffice').label}}
          @if(getAttributes('ldssOffice').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('ldssOffice').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['ldssOffice'] }">
            <ppl-dropdown-select formControlName="ldssOffice" id="ldssOffice" class="ppl-select"
              [options]="ldssOfficeValues" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              placeholder="Select LDSS Office" aria-required="true" aria-describedby="ldssOfficeError"
              aria-label="Select LDSS Office" [attr.aria-invalid]="validationErrors['ldssOffice'] ? 'true' : 'false'">
            </ppl-dropdown-select>

            @if (validationErrors['ldssOffice']) {
            <span id="ldssOfficeError" class="pl-1 error-message" role="alert">
              {{ validationErrors['ldssOffice'] }}
            </span>
            }
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('mcoOrgName')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="mcoOrgName"
          class="ppl-form-label">{{getAttributes('mcoOrgName').label}}
          @if(getAttributes('mcoOrgName').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('mcoOrgName').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['mcoOrgName'] }">
            <ppl-dropdown-select formControlName="mcoOrgName" id="mcoOrgName" class="ppl-select" [options]="mcoEntries"
              [optionLabel]="'orgName'" [optionValue]="'orgName'" [placeholder]="getAttributes('mcoOrgName')?.tooltip"
              aria-required="true" aria-describedby="mcoOrgNameError"
              [attr.aria-label]="getAttributes('mcoOrgName')?.tooltip"
              [attr.aria-invalid]="validationErrors['mcoOrgName'] ? 'true' : 'false'">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['mcoOrgName']) {
          <span id="mcoOrgNameError" class="pl-1 error-message" role="alert">
            {{ validationErrors['mcoOrgName'] }}
          </span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('currentFI')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="currentFI"
          class="ppl-form-label">{{getAttributes('currentFI').label}}
          @if(getAttributes('currentFI').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('currentFI').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['currentFI'] }">
            <ppl-dropdown-select formControlName="currentFI" id="currentFI" class="ppl-select"
              [options]="currentFIValues" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              placeholder="Select Current FI" aria-required="true" aria-describedby="currentFIError"
              aria-label="Select Current FI" [attr.aria-invalid]="validationErrors['currentFI'] ? 'true' : 'false'">
            </ppl-dropdown-select>

            @if (validationErrors['currentFI']) {
            <span id="currentFIError" class="pl-1 error-message" role="alert">
              {{ validationErrors['currentFI'] }}
            </span>
            }
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('fiOrgName')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="fiOrgName"
          class="ppl-form-label">{{getAttributes('fiOrgName').label}}
          @if(getAttributes('fiOrgName').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('fiOrgName').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['fiOrgName'] }">
            <ppl-dropdown-select formControlName="fiOrgName" id="fiOrgName" class="ppl-select" [options]="fiEntries"
              [optionLabel]="'orgName'" [optionValue]="'orgName'" [placeholder]="getAttributes('fiOrgName')?.tooltip"
              aria-required="true" aria-describedby="fiOrgNameError"
              [attr.aria-label]="getAttributes('fiOrgName')?.tooltip"
              [attr.aria-invalid]="validationErrors['fiOrgName'] ? 'true' : 'false'">
            </ppl-dropdown-select>
            <ng-container *ngIf="infoForm.get('fiOrgName')?.value === 'Other'">
              <div nz-tooltip class="mt-2">
                <input nz-input formControlName="newfiOrgName" id="newfiOrgName" placeholder="New {{getAttributes('fiOrgName').label}}"
                  [ngClass]="{'error': validationErrors['newfiOrgName'] }" />
              </div>
            </ng-container>
            @if (validationErrors['fiOrgName']) {
            <span id="fiOrgNameError" class="pl-1 error-message" role="alert">
              {{ validationErrors['fiOrgName'] }}
            </span>
            }
            @if (validationErrors['newfiOrgName']) {
              <span class="pl-1 error-message">{{validationErrors['newfiOrgName']}}</span>
            }
          </div>
        </nz-form-control>
        @if(!isMobile && getAttributes('fiOrgName').label !== 'Current FMS') {
        <button type="button" class="cdpap-button" [attr.aria-label]="'Search C D PAP Facilitator, clickable'" nz-icon
          [nzType]="'setting'" (click)="openCDPAPPopup()">
        </button>
        }
      </nz-form-item>
      }
      @if(isAttrAvailable('eligiblityStartDate')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="eligiblityStartDate"
          class="ppl-form-label">{{getAttributes('eligiblityStartDate').label}}
          @if(getAttributes('eligiblityStartDate').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('eligiblityStartDate')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <!-- <nz-date-picker [nzDisabledDate]="disabledStartDate" formControlName="eligiblityStartDate"
              id="eligiblityStartDate" [nzFormat]="'MM/dd/yyyy'"
              [nzPlaceHolder]="getAttributes('eligiblityStartDate').placeholder"
              [ngClass]="{'error': validationErrors['eligiblityStartDate'] }"></nz-date-picker> -->
            <ppl-date-picker formControlName="eligiblityStartDate" [id]="'eligiblityStartDate'" [showIcon]="true"
              dateFormat="mm/dd/yy" [yearRange]="'1900:2050'" [iconDisplay]="'input'" inputId="icondisplay"
              [panelStyleClass]="'custom-calendar-panel'" [maxDate]="minStartDate"
              [styleClass]="validationErrors['eligiblityStartDate'] ? 'error' : ''">
            </ppl-date-picker>
          </div>
          @if (validationErrors['eligiblityStartDate']) {
          <span class="pl-1 error-message">{{validationErrors['eligiblityStartDate']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('eligiblityEndDate')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="eligiblityEndDate"
          class="ppl-form-label">{{getAttributes('eligiblityEndDate').label}}
          @if(getAttributes('eligiblityEndDate').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('eligiblityEndDate')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <!-- <nz-date-picker formControlName="eligiblityEndDate" id="eligiblityEndDate" [nzFormat]="'MM/dd/yyyy'"
              [nzPlaceHolder]="getAttributes('eligiblityEndDate').placeholder"
              [ngClass]="{'error': validationErrors['eligiblityEndDate'] }"
              [nzDisabledDate]="disabledEndDate"></nz-date-picker> -->
            <ppl-date-picker formControlName="eligiblityEndDate" [id]="'eligiblityEndDate'" [showIcon]="true"
              dateFormat="mm/dd/yy" [yearRange]="'1900:2050'" [iconDisplay]="'input'" inputId="icondisplay"
              [panelStyleClass]="'custom-calendar-panel'" [minDate]="maxEndDate"
              [styleClass]="validationErrors['eligiblityEndDate'] ? 'error' : ''">
            </ppl-date-picker>
          </div>
          @if (validationErrors['eligiblityEndDate']) {
          <span class="pl-1 error-message">{{validationErrors['eligiblityEndDate']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('relationToParticipant')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" zFor="relationToParticipant"
          class="ppl-form-label">{{getAttributes('relationToParticipant').label}}
          @if(getAttributes('relationToParticipant').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip
          nzTooltipTitle="{{getAttributes('relationToParticipant').tooltip}}" nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['relationToParticipant'] }">
            <ppl-dropdown-select formControlName="relationToParticipant" id="relationToParticipant" class="ppl-select"
              [options]="relationshipOptions" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              placeholder="Select relation to participant" aria-required="true"
              aria-describedby="relationToParticipantError" aria-label="Select relation to participant"
              [attr.aria-invalid]="validationErrors['relationToParticipant'] ? 'true' : 'false'">
            </ppl-dropdown-select>

            @if (validationErrors['relationToParticipant']) {
            <span id="relationToParticipantError" class="pl-1 error-message" role="alert">
              {{ validationErrors['relationToParticipant'] }}
            </span>
            }
          </div>
        </nz-form-control>
      </nz-form-item>
      }

      @if(isAttrAvailable('showOnDirectory')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="showOnDirectory"
          class="ppl-form-label">{{getAttributes('showOnDirectory').label}}
          @if(getAttributes('showOnDirectory').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control [nzSm]="16" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('showOnDirectory')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <nz-radio-group [ngClass]="{'error': validationErrors['showOnDirectory'] }"
              formControlName="showOnDirectory" class="ppl-radio-group" id="showOnDirectory">
              @for(opt of radioOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['showOnDirectory']) {
          <span class="pl-1 error-message">{{validationErrors['showOnDirectory']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('yearsInState')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="yearsInState"
          class="ppl-form-label">{{getAttributes('yearsInState').label}}
          @if(getAttributes('yearsInState').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control [nzSm]="16" class="ppl-form-control">
          <input nz-input nz-tooltip nzTooltipTitle="{{getAttributes('yearsInState').tooltip}}"
            nzTooltipPlacement="topRight" formControlName="yearsInState" id="yearsInState"
            [ngClass]="{'error': validationErrors['yearsInState'] }"
            placeholder="{{getAttributes('yearsInState').placeholder}}" />
          @if (validationErrors['yearsInState']) {
          <span class="pl-1 error-message">{{validationErrors['yearsInState']}}</span>
          }
          <div class="notes">
            <p>
              This response may require additional background checks during enrolment.
            </p>
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('nonProfitStatus')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="nonProfitStatus"
          class="ppl-form-label">{{getAttributes('nonProfitStatus').label}}
          @if(getAttributes('nonProfitStatus').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
      </nz-form-item>
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="taxExempt"
          class="ppl-form-label">{{getAttributes('taxExempt').label}}
          @if(getAttributes('taxExempt').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div [ngClass]="{ 'error': validationErrors['taxExempt'] }">
            <ppl-dropdown-select formControlName="taxExempt" id="taxExempt" class="ppl-select"
              [options]="taxExemptOptions" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              [placeholder]="getAttributes('taxExempt').placeholder" aria-required="true"
              aria-describedby="taxExemptError" aria-label="Tax Exempt"
              [attr.aria-invalid]="validationErrors['taxExempt'] ? 'true' : 'false'">
            </ppl-dropdown-select>

            @if (validationErrors['taxExempt']) {
            <span id="taxExemptError" class="pl-1 error-message" role="alert">
              {{ validationErrors['taxExempt'] }}
            </span>
            }
          </div>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="nprftDocumentationReceived"
          class="ppl-form-label">{{getAttributes('nprftDocumentationReceived').label}}
          @if(getAttributes('nprftDocumentationReceived').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div [ngClass]="{ 'error': validationErrors['nprftDocumentationReceived'] }">
            <ppl-dropdown-select formControlName="nprftDocumentationReceived" id="nprftDocumentationReceived"
              class="ppl-select" [options]="[
              { lkpValueCode: 'yes', lkpValueName: 'Yes' },
              { lkpValueCode: 'no', lkpValueName: 'No' }
            ]" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              [placeholder]="getAttributes('nprftDocumentationReceived')?.placeholder" aria-required="true"
              aria-describedby="nprftDocumentationReceivedError" aria-label="Non-profit Documentation Received"
              [attr.aria-invalid]="validationErrors['nprftDocumentationReceived'] ? 'true' : 'false'"
              style="width: 100%; margin-bottom: 16px;">
            </ppl-dropdown-select>

            @if (validationErrors['nprftDocumentationReceived']) {
            <span id="nprftDocumentationReceivedError" class="pl-1 error-message" role="alert">
              {{ validationErrors['nprftDocumentationReceived'] }}
            </span>
            }
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('NPI')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="NPI" class="ppl-form-label">{{getAttributes('NPI').label}}
          @if(getAttributes('NPI').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('NPI')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input formControlName="NPI" id="NPI" placeholder="{{getAttributes('NPI').placeholder}}"
              [ngClass]="{'error': validationErrors['NPI'] }" />
          </div>
          @if (validationErrors['NPI']) {
          <span class="pl-1 error-message">{{validationErrors['NPI']}}</span>
          }
        </nz-form-control>
      </nz-form-item>

      }
      @if(isAttrAvailable('additionalDemographics')){
      <nz-divider class="divider"></nz-divider>
      <nz-form-label [nzXs]="24" nzFor="additionalDemographics" class="ppl-form-label"
        style="margin:8px 0 24px 0;">{{getAttributes('additionalDemographics').label}}
        @if(getAttributes('additionalDemographics').mandatory === 'Y'){
        <span>*</span>
        }
      </nz-form-label>
      @if(isAttrAvailable('race')){
      <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
        <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="race" class="ppl-form-label">{{getAttributes('race').label}}
          @if(getAttributes('race').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('race').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['race'] }">
            <ppl-dropdown-select formControlName="race" id="race" class="ppl-select" [options]="raceOptions"
              [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'" placeholder="Select relation to Participant"
              aria-required="true" aria-describedby="raceError" aria-label="Select relation to Participant"
              [attr.aria-invalid]="validationErrors['race'] ? 'true' : 'false'">
            </ppl-dropdown-select>

            @if (validationErrors['race']) {
            <span id="raceError" class="pl-1 error-message" role="alert">
              {{ validationErrors['race'] }}
            </span>
            }
          </div>
        </nz-form-control>
      </nz-form-item>
      }

      @if(isAttrAvailable('height')){
      <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
        <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="height" class="ppl-form-label">{{getAttributes('height').label}}
          @if(getAttributes('height').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <div nz-tooltip [nzTooltipTitle]="getAttributes('height')?.tooltip || ''" nzTooltipPlacement="topRight"
          class="height-input-container ppl-form-control">
          <input nz-input formControlName="heightFeet" id="heightFeet" placeholder="Feet"
            [ngClass]="{'error': validationErrors['heightFeet']}" />
          <span>Feet</span>
          <input nz-input formControlName="heightInches" id="heightInches" placeholder="Inches"
            [ngClass]="{'error': validationErrors['heightInches']}" />
          <span>Inches</span>
        </div>
      </nz-form-item>

      }
      @if(isAttrAvailable('weight')){
      <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
        <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="weight" class="ppl-form-label">
          {{getAttributes('weight').label}}
          @if(getAttributes('weight').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <div nz-tooltip [nzTooltipTitle]="getAttributes('weight')?.tooltip || ''" nzTooltipPlacement="topRight"
          class="weight-input-container ppl-form-control">
          <input nz-input formControlName="weight" id="weight" placeholder="{{getAttributes('weight').placeholder}}"
            [ngClass]="{'error': validationErrors['weight']}" />
          <span class="unit-label">Pounds</span>
        </div>
      </nz-form-item>
      }
      @if(isAttrAvailable('eyeColor')){
      <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
        <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="eyeColor"
          class="ppl-form-label">{{getAttributes('eyeColor').label}}
          @if(getAttributes('eyeColor').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('eyeColor').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['eyeColor'] }">
            <ppl-dropdown-select formControlName="eyeColor" id="eyeColor" class="ppl-select" [options]="eyeColors"
              [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'" placeholder="Select Eye Color"
              aria-required="true" aria-describedby="eyeColorError" aria-label="Select Eye Color"
              [attr.aria-invalid]="validationErrors['eyeColor'] ? 'true' : 'false'">
            </ppl-dropdown-select>

            @if (validationErrors['eyeColor']) {
            <span id="eyeColorError" class="pl-1 error-message" role="alert">
              {{ validationErrors['eyeColor'] }}
            </span>
            }
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('hairColor')){
      <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
        <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="hairColor"
          class="ppl-form-label">{{getAttributes('hairColor').label}}
          @if(getAttributes('hairColor').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('hairColor').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['hairColor'] }">
            <ppl-dropdown-select formControlName="hairColor" id="hairColor" class="ppl-select" [options]="hairColors"
              [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'" placeholder="Select Hair Color"
              aria-required="true" aria-describedby="hairColorError" aria-label="Select Hair Color"
              [attr.aria-invalid]="validationErrors['hairColor'] ? 'true' : 'false'">
            </ppl-dropdown-select>

            @if (validationErrors['hairColor']) {
            <span id="hairColorError" class="pl-1 error-message" role="alert">
              {{ validationErrors['hairColor'] }}
            </span>
            }
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('birthPlace')){
      <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
        <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="birthPlace"
          class="ppl-form-label">{{getAttributes('birthPlace').label}}
          @if(getAttributes('birthPlace').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="" nzTooltipPlacement="topRight">
            <input nz-input formControlName="birthCity" id="birthCity" placeholder="City" />
          </div>
        </nz-form-control>
        <nz-form-control class="ppl-form-control" style="margin: 0px 4px;">
          <div nz-tooltip [nzTooltipTitle]="" nzTooltipPlacement="topRight">
            <input nz-input formControlName="birthState" id="birthState" placeholder="State" />
          </div>
        </nz-form-control>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="" nzTooltipPlacement="topRight">
            <input nz-input formControlName="birthCountry" id="birthCountry" placeholder="Country" />
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      <nz-divider class="divider"></nz-divider>
      }
      @if(isAttrAvailable('addToED')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="addToED" class="ppl-form-label">{{getAttributes('addToED').label}}
          @if(getAttributes('addToED').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control [nzSm]="16" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('addToED')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="addToED" class="ppl-radio-group" id="addToED"
              [ngClass]="{'error': validationErrors['addToED'] }">
              @for(opt of radioOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['addToED']) {
          <span class="pl-1 error-message">{{validationErrors['addToED']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      
      @if(isAttrAvailable('applicationSource') && !fromInterest){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="applicationSource"
          class="ppl-form-label">{{getAttributes('applicationSource').label}}
          @if(getAttributes('applicationSource').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip
          nzTooltipTitle="{{getAttributes('applicationSource').tooltip}}" nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['applicationSource'] }">
            <ppl-dropdown-select formControlName="applicationSource" id="applicationSource" class="ppl-select"
              [options]="applicationSourceList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              [placeholder]="getAttributes('applicationSource')?.placeholder" aria-required="true"
              aria-describedby="applicationSourceError"
              [attr.aria-label]="getAttributes('applicationSource')?.placeholder"
              [attr.aria-invalid]="validationErrors['applicationSource'] ? 'true' : 'false'">
            </ppl-dropdown-select>

            @if (validationErrors['applicationSource']) {
            <span id="applicationSourceError" class="pl-1 error-message" role="alert">
              {{ validationErrors['applicationSource'] }}
            </span>
            }
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('contactStsReasonLkp')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactStsReasonLkp"
          class="ppl-form-label">{{getAttributes('contactStsReasonLkp').label}}
          @if(getAttributes('contactStsReasonLkp').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nz-tooltip
          nzTooltipTitle="{{getAttributes('contactStsReasonLkp').tooltip}}" nzTooltipPlacement="topRight">
          <div [ngClass]="{ 'error': validationErrors['contactStsReasonLkp'] }">
            <ppl-dropdown-select formControlName="contactStsReasonLkp" id="contactStsReasonLkp" class="ppl-select"
              [options]="contactStsReasonLkpList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              [placeholder]="getAttributes('contactStsReasonLkp')?.placeholder" aria-required="true"
              aria-describedby="contactStsReasonLkpError"
              [attr.aria-label]="getAttributes('contactStsReasonLkp')?.placeholder"
              [attr.aria-invalid]="validationErrors['contactStsReasonLkp'] ? 'true' : 'false'">
            </ppl-dropdown-select>

            @if (validationErrors['contactStsReasonLkp']) {
            <span id="contactStsReasonLkpError" class="pl-1 error-message" role="alert">
              {{ validationErrors['contactStsReasonLkp'] }}
            </span>
            }
          </div>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('contactStsComments')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="contactStsComments"
          class="ppl-form-label">{{getAttributes('contactStsComments').label}}
          @if(getAttributes('contactStsComments').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('contactStsComments')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <nz-textarea-count [nzMaxCharacterCount]="300">
              <textarea rows="4" cols="40" nz-input formControlName="contactStsComments" id="contactStsComments"
                class="ppl-form-control" placeholder="{{getAttributes('contactStsComments').placeholder}}"
                [ngClass]="{'error': validationErrors['contactStsComments'] }" [maxlength]="300"></textarea>
            </nz-textarea-count>
          </div>
          @if (validationErrors['contactStsComments']) {
          <span class="pl-1 error-message">{{validationErrors['contactStsComments']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('isSnapReceived')){
      <h4 class="additional-demo-header" style="margin-bottom: 24px;">Additional Demographics</h4>
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="16" [nzXs]="24" nzFor="isSnapReceived"
          class="ppl-form-label">{{getAttributes('isSnapReceived').label}}
          @if(getAttributes('isSnapReceived').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control [nzSm]="8" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('isSnapReceived')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="isSnapReceived" class="ppl-radio-group" id="isSnapReceived"
              [ngClass]="{'error': validationErrors['isSnapReceived'] }">
              @for(opt of radioBooleanOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['isSnapReceived']) {
          <span class="pl-1 error-message">{{validationErrors['isSnapReceived']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('isTanfReceived')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="16" [nzXs]="24" nzFor="isTanfReceived"
          class="ppl-form-label">{{getAttributes('isTanfReceived').label}}
          @if(getAttributes('isTanfReceived').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control [nzSm]="8" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('isTanfReceived')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="isTanfReceived" class="ppl-radio-group" id="isTanfReceived"
              [ngClass]="{'error': validationErrors['isTanfReceived'] }">
              @for(opt of radioBooleanOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['isTanfReceived']) {
          <span class="pl-1 error-message">{{validationErrors['isTanfReceived']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('isSsiReceived')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="16" [nzXs]="24" nzFor="isSsiReceived"
          class="ppl-form-label">{{getAttributes('isSsiReceived').label}}
          @if(getAttributes('isSsiReceived').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control [nzSm]="8" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('isSsiReceived')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="isSsiReceived" class="ppl-radio-group" id="isSsiReceived"
              [ngClass]="{'error': validationErrors['isSsiReceived'] }">
              @for(opt of radioBooleanOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['isSsiReceived']) {
          <span class="pl-1 error-message">{{validationErrors['isSsiReceived']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('isUnemployed')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="16" [nzXs]="24" nzFor="isUnemployed"
          class="ppl-form-label">{{getAttributes('isUnemployed').label}}
          @if(getAttributes('isUnemployed').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control [nzSm]="8" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('isUnemployed')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="isUnemployed" class="ppl-radio-group" id="isUnemployed"
              [ngClass]="{'error': validationErrors['isUnemployed'] }">
              @for(opt of radioBooleanOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['isUnemployed']) {
          <span class="pl-1 error-message">{{validationErrors['isUnemployed']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('isVeteran')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="16" [nzXs]="24" nzFor="isVeteran"
          class="ppl-form-label">{{getAttributes('isVeteran').label}}
          @if(getAttributes('isVeteran').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control [nzSm]="8" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('isVeteran')?.tooltip || ''" nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="isVeteran" class="ppl-radio-group" id="isVeteran"
              [ngClass]="{'error': validationErrors['isVeteran'] }">
              @for(opt of radioBooleanOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['isVeteran']) {
          <span class="pl-1 error-message">{{validationErrors['isVeteran']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('isDisabilityComp') && infoForm.get('isVeteran')?.value){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="16" [nzXs]="24" nzFor="isDisabilityComp"
          class="ppl-form-label">{{getAttributes('isDisabilityComp').label}}
          @if(getAttributes('isDisabilityComp').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control [nzSm]="8" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('isDisabilityComp')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="isDisabilityComp" class="ppl-radio-group" id="isDisabilityComp"
              [ngClass]="{'error': validationErrors['isDisabilityComp'] }">
              @for(opt of radioBooleanOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['isDisabilityComp']) {
          <span class="pl-1 error-message">{{validationErrors['isDisabilityComp']}}</span>
          }
        </nz-form-control>
      </nz-form-item>}
      @if(isAttrAvailable('isWotcCertified')){
      <nz-form-item class="ppl-form-item">
        <nz-form-control class="ppl-form-control">
          <input nz-input type="checkbox" class="checkbox" formControlName="isWotcCertified" />
          <span style="margin-left: 8px; font-weight: 600;">{{getAttributes('isWotcCertified').label}}</span>
          <p>
            <span *ngIf="validationErrors['isWotcCertified']" class="pl-1 error-message">
              {{validationErrors['isWotcCertified']}}
            </span>
          </p>
        </nz-form-control>
      </nz-form-item>
      }
      @if(isAttrAvailable('referralSource')){
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="referralSource" class="ppl-form-label">
          <span id="referralSource-label">
            {{getAttributes('referralSource').label}}
            @if(getAttributes('referralSource').mandatory === 'Y'){
            <span>*</span>
            }
          </span>
        </nz-form-label>
        <nz-form-control [nzSm]="16" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('referralSource')?.tooltip || ''" nzTooltipPlacement="topRight">

            <ppl-dropdown-select formControlName="referralSource" id="referralSource" [options]="referralSources"
                  [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'" [placeholder]="getAttributes('referralSource')?.placeholder" (selectionChange)="onReferralSourceChange($event)"></ppl-dropdown-select>
          </div>
          @if (validationErrors['referralSource']) {
          <span class="pl-1 error-message">{{validationErrors['referralSource']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
      }
      @if(showOtherReferralSource && isAttrAvailable('otherReferralSource')){
        <nz-form-item class="ppl-form-item">
          <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="otherReferralSource" class="ppl-form-label">
            <span id="otherReferralSource-label">
              {{getAttributes('otherReferralSource').label}}
              @if(getAttributes('otherReferralSource').mandatory === 'Y'){
              <span>*</span>
              }
            </span>
          </nz-form-label>
          <nz-form-control [nzSm]="16" class="ppl-form-control">
            <div nz-tooltip [nzTooltipTitle]="getAttributes('otherReferralSource')?.tooltip || ''" nzTooltipPlacement="topRight">
            <input nz-input formControlName="otherReferralSource" id="otherReferralSource"
                placeholder="{{getAttributes('otherReferralSource').placeholder}}"
                [ngClass]="{'error': validationErrors['maiden_name'] }" />
            </div>
            @if (validationErrors['otherReferralSource']) {
            <span class="pl-1 error-message">{{validationErrors['otherReferralSource']}}</span>
            }
          </nz-form-control>
        </nz-form-item>
      }
      @if (showParentGuardianSection) {
      <ppl-accordion [title]="'Parent/Guardian Information'" [isOpen]="true">
        <ppl-parent-guardian [parents]="parents" [validationErrors]="validationErrors"
          [addressErrors]="parentAddressErrors"
          [readonly]="formReadonly"
          (deleteSavedRecords)="onDeleteSavedRecords($event)"></ppl-parent-guardian>
      </ppl-accordion>
      }
      @if (showProviderClassification) {
      <nz-divider></nz-divider>
      <h3 class="classification-heading">Provider Classification</h3>
      <!-- 'edit' either way: a readonly wizard disables infoForm, so the questions render as
           disabled controls in line with the rest of the step. 'read' is the detail page's
           label/value layout. -->
      <ppl-provider-classification-questions #classificationQuestions
        [form]="infoForm"></ppl-provider-classification-questions>
      }
    </form>
  </nz-card>
</div>}
@else if(mode==="read"){
  @if(isAttrAvailable('associationType')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{ getAttributes('associationType').label }} :</div>
  <div nz-col nzSpan="16">{{providerType}}</div>
</div>
}
@if(isAttrAvailable('businessName')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{ getAttributes('businessName').label }} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['businessName']}}</div>
</div>
}
@if(isAttrAvailable('vendorName')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{ getAttributes('vendorName').label }} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['vendorName']}}</div>
</div>
}
@if(isAttrAvailable('doingBusinessAs')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{ getAttributes('doingBusinessAs').label }} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['dbaName']}}</div>
</div>
}
@if(isAttrAvailable('fname')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{ getAttributes('fname').label }} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['fname']}}</div>
</div>
}
@if(isAttrAvailable('mname')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('mname').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['mname']}}</div>
</div>
}
@if(isAttrAvailable('lname')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('lname').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['lname']}}</div>
</div>
}
@if(isAttrAvailable('maiden_name')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('maiden_name').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['maiden_name']}}</div>
</div>
}
@if(isAttrAvailable('dob')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('dob').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['dob'] }}</div>
</div>
}
@if(isAttrAvailable('conservatorship')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('conservatorship').label}} :</div>
  <div nz-col nzSpan="16">{{getLookupValue(conservatorshipTypes, filledInfo['conservatorship'])}}</div>
</div>
}
@if(isAttrAvailable('gender')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('gender').label}} :</div>
  <div nz-col nzSpan="16">{{(getLookupValue(gender, filledInfo['gender']))}}</div>
</div>
}
@if(isAttrAvailable('servicesAtBusinessLocation')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('servicesAtBusinessLocation').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['servicesAtBusinessLocation'] }}</div>
</div>
}
@if(isAttrAvailable('servingIndividualsWithDisabilities')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('servingIndividualsWithDisabilities').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['servingIndividualsWithDisabilities'] }}</div>
</div>
}
@if(isAttrAvailable('state') && this.state){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{ getAttributes('state').label }} :</div>
  <div nz-col nzSpan="16">{{ (getLookupValue(states, this.state))}}</div>
</div>
}
@if(isAttrAvailable('SSN')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('SSN').label}} :</div>
  <div nz-col nzSpan="16">{{ maskSSN(filledInfo['SSN']) }}</div>
</div>
}
@if(isAttrAvailable('ITIN')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('ITIN').label}} :</div>
  <div nz-col nzSpan="16">{{ maskITIN(filledInfo['ITIN']) }}</div>
</div>
}
@if(isAttrAvailable('CIN')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('CIN').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['CIN']}}</div>
</div>
}
@if(isAttrAvailable('EIN')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('EIN').label}} :</div>
  <div nz-col nzSpan="16">{{ maskEIN(filledInfo['EIN'])}}</div>
</div>
}
@if(isAttrAvailable('TIN')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('TIN').label}} :</div>
  <div nz-col nzSpan="16">{{ maskSSN(filledInfo['TIN']) }}</div>
</div>
}
@if(isAttrAvailable('currentFms')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('currentFms').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['currentFms']}}</div>
</div>
}
@if(isAttrAvailable('recieveGoodsAndServices')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('recieveGoodsAndServices').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['recieveGoodsAndServices'] }}</div>
</div>
}
@if(isAttrAvailable('waiver')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('waiver').label}} :</div>
  <div nz-col nzSpan="16">{{ getLookupValue(waiver, filledInfo['waiver']) }}</div>
</div>
}
@if(isAttrAvailable('ldssOffice')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('ldssOffice').label}} :</div>
  <div nz-col nzSpan="16">{{ getLookupValue(ldssOfficeValues, filledInfo['ldssOffice']) }}</div>
</div>
}
@if(isAttrAvailable('mcoOrgName')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('mcoOrgName').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['mcoOrgName'] }}</div>
</div>
}
@if(isAttrAvailable('currentFI')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('currentFI').label}} :</div>
  <div nz-col nzSpan="16">{{ getLookupValue(currentFIValues, filledInfo['currentFI']) }}</div>
</div>
}
@if(isAttrAvailable('fiOrgName')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('fiOrgName').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['fiOrgName'] }}</div>
</div>
}
@if(isAttrAvailable('eligiblityStartDate')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('eligiblityStartDate').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['eligiblityStartDate'] }}</div>
</div>
}
@if(isAttrAvailable('eligiblityEndDate')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('eligiblityEndDate').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['eligiblityEndDate'] }}</div>
</div>
}
@if(isAttrAvailable('relationToParticipant')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('relationToParticipant').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo.relationToParticipant ? getLookupValue(relationshipOptions,
    filledInfo['relationToParticipant']) : filledInfo.relationToParticipant}}</div>
</div>
}
@if(isAttrAvailable('showOnDirectory')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('showOnDirectory').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['showOnDirectory']}}</div>
</div>
}
@if(isAttrAvailable('yearsInState')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('yearsInState').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['yearsInState']}}</div>
</div>
}
@if(isAttrAvailable('nonProfitStatus')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('nonProfitStatus').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['nonProfitStatus']}}</div>
</div>
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('taxExempt').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo.taxExempt ? getLookupValue(taxExemptOptions, filledInfo['taxExempt']) :
    filledInfo.taxExempt}}</div>
</div>
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('nprftDocumentationReceived').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['nprftDocumentationReceived']}}</div>
</div>
}
@if(isAttrAvailable('NPI')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('NPI').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['NPI']}}</div>
</div>
}
@if(isAttrAvailable('isProvidingServices')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('isProvidingServices').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['isProvidingServices'] }}</div>
</div>
}
@if(isAttrAvailable('servicesRendered')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{ getAttributes('servicesRendered').label }} :</div>
  <div nz-col nzSpan="16">{{ getLookupValue(services, filledInfo['servicesRendered'])}}</div>
</div>
}
@if(showServicesRenderedAdditionalDetails && isAttrAvailable('servicesRenderedAdditionalDetails')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('servicesRenderedAdditionalDetails').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['servicesRenderedAdditionalDetails']}}</div>
</div>
}
@if(isAttrAvailable('program')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('program').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['program']}}</div>
</div>
}
@if(isAttrAvailable('regionalCenter')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('regionalCenter').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['regionalCenterName'] }}</div>
</div>
}
@if(isAttrAvailable('applicationSource') && !fromInterest){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('applicationSource').label}} :</div>
  <div nz-col nzSpan="16">{{ getLookupValue(applicationSourceList, filledInfo['applicationSource']) }}</div>
</div>
}
@if(isAttrAvailable('contactStsReasonLkp')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('contactStsReasonLkp').label}} :</div>
  <div nz-col nzSpan="16">{{ getLookupValue(contactStsReasonLkpList, filledInfo['contactStsReasonLkp']) }}</div>
</div>
}
@if(isAttrAvailable('contactStsComments')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('contactStsComments').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['contactStsComments'] }}</div>
</div>
}
@if(isAttrAvailable('additionalDemographics')){
<div nz-row class="ppl-read-label">Additional Demographics :</div>
@if(isAttrAvailable('race')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('race').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo.race ? getLookupValue(raceOptions, filledInfo['race']) : filledInfo.race}}</div>
</div>
}
@if(isAttrAvailable('height')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('height').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['heightFeet']}} Feet {{ filledInfo['heightInches'] || 0}} Inches</div>
</div>
}
@if(isAttrAvailable('weight')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('weight').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['weight']}} Pounds</div>
</div>
}
@if(isAttrAvailable('eyeColor')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('eyeColor').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo.eyeColor ? getLookupValue(eyeColors, filledInfo['eyeColor']) :
    filledInfo.eyeColor}}</div>
</div>
}
@if(isAttrAvailable('hairColor')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('hairColor').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo.hairColor ? getLookupValue(hairColors, filledInfo['hairColor']) :
    filledInfo.hairColor}}</div>
</div>
}
@if(isAttrAvailable('birthPlace')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('birthPlace').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['birthCity']}} {{ filledInfo['birthState']}} {{ filledInfo['birthCountry']}}
  </div>
</div>
}
}
@if(isAttrAvailable('isSnapReceived')){
<h5 class="additional-demo-header" style="margin: 16px 0;">Additional Demographics :</h5>
<div nz-row>
  <div nz-col nzSpan="16" class="ppl-read-label">{{getAttributes('isSnapReceived').label}}</div>
  <div nz-col nzSpan="8">{{ getBooleanLabel(filledInfo['isSnapReceived']) }}</div>
</div>
}
@if(isAttrAvailable('isTanfReceived')){
<div nz-row>
  <div nz-col nzSpan="16" class="ppl-read-label">{{getAttributes('isTanfReceived').label}}</div>
  <div nz-col nzSpan="8">{{ getBooleanLabel(filledInfo['isTanfReceived']) }}</div>
</div>
}
@if(isAttrAvailable('isSsiReceived')){
<div nz-row>
  <div nz-col nzSpan="16" class="ppl-read-label">{{getAttributes('isSsiReceived').label}}</div>
  <div nz-col nzSpan="8">{{ getBooleanLabel(filledInfo['isSsiReceived']) }}</div>
</div>
}
@if(isAttrAvailable('isUnemployed')){
<div nz-row>
  <div nz-col nzSpan="16" class="ppl-read-label">{{getAttributes('isUnemployed').label}}</div>
  <div nz-col nzSpan="8">{{ getBooleanLabel(filledInfo['isUnemployed']) }}</div>
</div>
}
@if(isAttrAvailable('isVeteran')){
<div nz-row>
  <div nz-col nzSpan="16" class="ppl-read-label">{{getAttributes('isVeteran').label}}</div>
  <div nz-col nzSpan="8">{{ getBooleanLabel(filledInfo['isVeteran']) }}</div>
</div>
}
@if(isAttrAvailable('isDisabilityComp') && infoForm.get('isVeteran')?.value){
<div nz-row>
  <div nz-col nzSpan="16" class="ppl-read-label">{{getAttributes('isDisabilityComp').label}}</div>
  <div nz-col nzSpan="8">{{ getBooleanLabel(filledInfo['isDisabilityComp']) }}</div>
</div>
}
@if(isAttrAvailable('isWotcCertified')){
<div nz-row>
  <div nz-col nzSpan="16" class="ppl-read-label">{{getAttributes('isWotcCertified').label}} :</div>
  <div nz-col nzSpan="8">{{ getBooleanLabel(filledInfo['isWotcCertified']) }}</div>
</div>
}
@if(isAttrAvailable('referralSource')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('referralSource').label}} :</div>
  <div nz-col nzSpan="16">{{ getLookupValue(referralSources, filledInfo['referralSource']) }}</div>
</div>
}
@if(showOtherReferralSource && isAttrAvailable('otherReferralSource')){
<div nz-row>
  <div nz-col nzSpan="8" class="ppl-read-label">{{getAttributes('otherReferralSource').label}} :</div>
  <div nz-col nzSpan="16">{{ filledInfo['otherReferralSource']}}</div>
</div>
}
@if (showParentGuardianSection) {
<div nz-row>
  <div nz-col nzSpan="24" class="ppl-read-label">Parent/Guardian Information</div>
</div>
<ppl-parent-guardian [parents]="parents" [mode]="'read'"></ppl-parent-guardian>
}
}
